import { render, staticRenderFns } from "./SOCart.vue?vue&type=template&id=615ad81e&scoped=true&"
import script from "./SOCart.vue?vue&type=script&lang=ts&"
export * from "./SOCart.vue?vue&type=script&lang=ts&"
import style0 from "./SOCart.vue?vue&type=style&index=0&id=615ad81e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ad81e",
  null
  
)

export default component.exports